import { AuthServiceInterface } from '@/services/interface/AuthService.js'
import users from '@/store/modules/demo/users.json'

export class DemoAuthService extends AuthServiceInterface {
  static async authenticate () {
    return Promise.resolve(users[0])
  }

  static async userInfo () {
    return Promise.resolve({
      data: {
        userInfo: users[0]
      }
    })
  }
}
